module.exports = __webpack_public_path__ + "static/media/ITCFranklinGothicStd-Book.1828ae8e.ttf";